/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCursorCrosshair = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M11 21h3v-7h7v-3h-7V4h-3v7H4v3h7z" /></svg>;
export default SvgCursorCrosshair;